<template>
  <b-container>
    <b-row>
      <b-col>
        <h4>404: File Not Found</h4>
        <p>I'm sorry. The server couldn't find this page.</p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Storage from "store2";

export default {
  data() {
    return {
      localData: {}
    };
  },

  computed: {
    debug() {
      return "debug" in this.$route.query;
    }
  },
  methods: {
    loadLocalStorage() {
      console.log(Storage());
      this.localData = Storage();
    }
  }
};
</script>

<style lang="css" scoped>
h4{
  font-weight: normal;
  }
</style>
